import { createContext, useEffect, useState } from 'react';

interface ITableProvider {
  children: React.ReactNode;
}

interface ITableContext {
  setShowTableSlider: (...args: any) => void;
  showTableSlide: boolean;
  sliderComp: React.ReactNode;
  setSliderComp: (...args: any) => void;
  tableBaseUrl?: string;
  setTableBaseUrl: (...args: any) => void;
  tableFilterUrl?: string;
  setTableFilterUrl: (...args: any) => void;
  tableFilterRecord?: Record<string, string>;
  handleSetTableFilterRecord: (...args: any) => void;
  refreshTable: boolean;
  setRefreshTable: (arg: boolean) => void;

  // This are used to in filter dropdown  components to show selected filters
  tableSelectedFilter: Record<string, any>;
  setTableSelectedFilter: (...args: any) => void;

  // This are used to in sort dropdown  components to show selected filters
  tableSortSelectedFilter: Record<string, any>;
  setTableSortSelectedFilter: (...args: any) => void;
}

export const TableContext = createContext<ITableContext | null>(null);

export const TableProvider: React.FC<ITableProvider> = ({ children }) => {
  const [refreshTable, setRefreshTable] = useState<boolean>(true);
  const [showTableSlide, setShowTableSlider] = useState(false);
  const [sliderComp, setSliderComp] = useState<React.ReactNode | null>(null);
  const [tableBaseUrl, setTableBaseUrl] = useState<string>();
  const [tableSortSelectedFilter, setTableSortSelectedFilter] = useState<
    Record<string, any>
  >({});

  const [tableSelectedFilter, setTableSelectedFilter] = useState<
    Record<string, any>
  >({});

  const [tableFilterUrl, setTableFilterUrl] = useState<string>();
  const [tableFilterRecord, setTableFilterRecord] =
    useState<Record<string, string>>();

  useEffect(() => {
    if (tableFilterRecord) {
      const queryString = Object.entries(tableFilterRecord)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
        )
        .join('&');

      if (tableBaseUrl?.includes('?')) {
        setTableFilterUrl(`${tableBaseUrl}&${queryString}`);
      } else {
        setTableFilterUrl(`${tableBaseUrl}?${queryString}`);
      }
    }
    // eslint-disable-next-line
  }, [tableFilterRecord]);

  const handleSetTableFilterRecord = (filter: Record<string, string>) => {
    const tempObj: Record<string, any> = { ...tableFilterRecord };

    Object.entries(filter).forEach(([key, value]) => {
      if (String(value) === '') {
        delete tempObj[key];
      } else {
        tempObj[key] = value;
      }
    });

    setTableFilterRecord({ ...tempObj });
  };

  return (
    <TableContext.Provider
      value={{
        showTableSlide,
        setShowTableSlider,
        sliderComp,
        setSliderComp,
        tableBaseUrl,
        setTableBaseUrl,
        tableFilterUrl,
        setTableFilterUrl,
        tableFilterRecord,
        handleSetTableFilterRecord,
        refreshTable,
        setRefreshTable,
        tableSelectedFilter,
        setTableSelectedFilter,
        tableSortSelectedFilter: tableSortSelectedFilter || {},
        setTableSortSelectedFilter,
      }}
    >
      {children}
    </TableContext.Provider>
  );
};
